import React from "react";
import { useParams, Link } from "react-router-dom";
import { useCollection } from "api/use-intercom";
import LoadingSpinner from "components/loading-spinner";
// import { useTranslation } from "react-i18next";
import "./article.css";
import ScrollToTop from "components/scroll-to-top";

export default function CollectionPage() {
  const { id: rawId } = useParams();
  const id = rawId.split("-")[0];
  const { data: collection, isLoading, error } = useCollection(id);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white">
        <ScrollToTop />
        <div className="container mx-auto px-4 py-8">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-white">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-red-600 mb-4">
              Error loading collection
            </h1>
            <p className="text-gray-600">{error.message}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!collection) {
    return (
      <div className="min-h-screen bg-white">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Sorry, we couldn't find this collection.
            </h1>
            <p className="text-gray-600">
              The collection you're looking for might have been moved or
              deleted.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-300/25 flex justify-center">
      <ScrollToTop />
      <div className="md:px-8 my-0 lg:my-12 py-8 md:py-0 relative bg-white rounded-xl w-full lg:w-[800px]">
        <div className="md:mt-10 px-[1rem] flex items-center text-sm text-tertiary flex-wrap gap-y-2 md:gap-y-0">
          <Link
            to="/en-US/help"
            className="hover:text-gray-600 whitespace-nowrap"
          >
            Help Center
          </Link>
          <span className="material-symbols-outlined scale-75 whitespace-nowrap">
            chevron_forward
          </span>
          <div className="text-black whitespace-nowrap">{collection.name}</div>
        </div>
        <div className="px-4 py-8 flex flex-col">
          <div className="flex gap-8 border-b border-gray-300 md:-mx-4 px-4 pb-8">
            <div className="w-16 h-16 bg-red shrink-0 rounded-lg flex mt-1 justify-center items-center">
              <span className="material-symbols-outlined text-white">
                folder
              </span>
            </div>
            <div>
              <h1 className="text-[1.5rem] font-bold">{collection.name}</h1>
              {collection.description && (
                <p className="text-tertiary text-2xl">
                  {collection.description}
                </p>
              )}
            </div>
          </div>
          <div className="flex flex-col">
            {collection?.articles?.data?.map((article, index, array) => (
              <Link
                to={`/en-US/help/articles/${article.id}`}
                key={article.id}
                className={`hover:bg-blue-300/25 min-h-24 flex gap-8 items-center md:-mx-4 px-4 ${
                  index !== array.length - 1 ? " border-gray-300 " : ""
                }`}
              >
                <div className="w-16 h-16 bg-blue-300/25 rounded-lg flex justify-center items-center shrink-0">
                  <span className="material-symbols-outlined ">article</span>
                </div>
                <div className="flex flex-col gap-1 w-full my-4 py-2">
                  <div className="">{article.title}</div>
                  <div className="text-tertiary">{article.description}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
